export interface ImageApi {}
